import * as ProgramApi from 'api/program';
import { DATA_BAG } from 'defs/offlineAvailability';
import { call, put, select, take } from 'redux-saga/effects';
import { actionCreators as connectionAC, getIsOnline } from 'store/connection';
import { actionTypes as loginAT, getHasAuthenticationLoaded, getIsAuthenticated } from 'store/login';
import { actionCreators as offlineAvailabilityAC } from 'store/offlineAvailability';
import { getIsPreviewUser } from 'store/profile';
import { actionCreators } from 'store/programOverview';

export function* loadProgramOverview() {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkFetchRequestError());
	}

	yield put(actionCreators.doSetLoadingState(true));

	const isAuthenticated = yield select(getIsAuthenticated);
	const hasAuthenticationLoaded = yield select(getHasAuthenticationLoaded);

	if (!isAuthenticated && !hasAuthenticationLoaded) {
		yield take(loginAT.LOGIN_STATUS_KNOWN);
	}

	try {
		const isPreviewUser = yield select(getIsPreviewUser);
		const overviewData = yield call(ProgramApi.fetchProgramOverview, isPreviewUser);

		yield put(offlineAvailabilityAC.doRegisterDataBag(DATA_BAG.PROGRAMS));

		yield put(actionCreators.doLoadOverviewSuccess(overviewData));
	} catch (err) {
		yield put(actionCreators.doLoadOverviewFailure(err));
	}
}
